var app = {
	header: {
		build: "Build",
		closeButton: "Schließen",
		copyrightLabel: "Copyright",
		helpLabel: "Hilfe",
		legalNoticeLabel: "Impressum",
		logoutButton: "Abmelden",
		menuLabel: "Menü",
		module: "Modul",
		myData: "Meine Daten",
		noUserDataLabel: "Keine Daten vorhanden",
		notificationsLabel: "Nachrichten",
		privacyPolicyLabel: "Datenschutz",
		search: "Suche",
		searchPlaceholder: "Suchbegriff oder Frage",
		serviceAppLabel: "Servicefälle",
		settingsLabel: "Einstellungen",
		shopLabel: "Shop",
		smartFactorySuiteLabel: "Smart-Factory Suite",
		softwareInformation: "Softwareinformationen",
		toMytrumpf: "Zu MyTRUMPF",
		toTrumpfCom: "Zu trumpf.com",
		userLabel: "Profil",
		userProfileLinkText: "Nutzer Profil",
		version: "Version"
	}
};
var contentLoadingError = "Inhalt konnte nicht geladen werden";
var dashboard = {
	cancel: {
		button: "Abbrechen"
	},
	edit: {
		button: "Bearbeiten"
	},
	reset: {
		button: "Zurücksetzen"
	},
	save: {
		button: "Speichern"
	},
	share: {
		button: "Teilen"
	}
};
var fileUpload = {
	invalidFileType: "Die Datei ist vom falschen Typ",
	maxFileSize: "Die Datei ist größer als erlaubt (max. {{maxSizeInMb}} MB)",
	maxFilesReached: "Maximale Anzahl an Dateien erreicht"
};
var filter = {
	clear: "Filter zurücksetzen",
	clearAll: "Alle Filter zurücksetzen",
	label: "Filter"
};
var general = {
	applyButton: "Anwenden",
	closeButton: "Schließen",
	nextButton: "Weiter",
	prevButton: "Zurück",
	resetButton: "Zurücksetzen"
};
var locationMap = {
	locationLink: {
		label: "Zum Standort"
	}
};
var machineDiscontinuation = {
	linkText: "Mehr erfahren"
};
var notifications = {
	button: {
		loadMore: "Mehr laden"
	},
	date: {
		lastMonth: "Letzter Monat",
		lastWeek: "Letzte Woche",
		older: "Älter",
		thisMonth: "Dieser Monat",
		thisWeek: "Diese Woche",
		today: "Heute",
		yesterday: "Gestern"
	},
	error: {
		general: "Aktuell können keine Benachrichtigungen angezeigt werden. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.",
		unauthorized: "Bitte melden Sie sich an, um Benachrichtigungen zu sehen."
	},
	info: {
		activateSettings: "Um Benachrichtigungen zu erhalten, aktivieren Sie diese bitte in den Einstellungen",
		noNotification: "Derzeit liegen keine Benachrichtigungen für Sie vor."
	},
	title: "Benachrichtigungen"
};
var orderTracking = {
	label: "Auftragsverfolgung verfügbar"
};
var results = {
	counter: {
		label: "Treffer"
	}
};
var scrollToTop = {
	label: "Nach oben scrollen"
};
var slider = {
	nextButton: {
		label: "Nächste Folie"
	},
	paginationBullet: {
		label: "Folie"
	},
	prevButton: {
		label: "Vorherige Folie"
	}
};
var sorting = {
	ascending: "Aufsteigend",
	descending: "Absteigend"
};
var tab = {
	next: "Nach rechts scrollen",
	previous: "Nach links scrollen"
};
var userAccount = {
	addAccount: {
		button: "Weiteres Konto hinzufügen"
	},
	address: {
		label: "Adresse"
	},
	email: {
		label: "E-Mail"
	},
	language: {
		label: "Sprache",
		locale: "Gebietsschema",
		select: "Sprache wählen",
		settings: "Spracheinstellungen"
	},
	loggedOut: {
		message: "Sie sind nicht angemeldet"
	},
	login: {
		button: "Anmelden"
	},
	name: {
		label: "Name"
	},
	phone: {
		label: "Telefon"
	},
	switchAccount: {
		button: "Konto wechseln"
	},
	upgradeAccount: {
		button: "Konto aktualisieren"
	}
};
var widget = {
	filter: {
		machine: {
			filter: "Machinen filtern",
			label: "Maschinen",
			option: {
				all: "Alle Maschinen"
			},
			select: "Machine auswählen"
		},
		period: {
			label: "Zeitraum",
			option: {
				currentMonth: "Dieser Monat",
				currentWeek: "Diese Woche",
				lastMonth: "Voriger Monat",
				lastWeek: "Vorige Woche",
				today: "Heute",
				yesterday: "Gestern"
			}
		}
	}
};
var widgetRegistry = {
	allWidgets: {
		label: "Meine Widgets"
	},
	noDescriptionAvailable: "Keine Beschreibung verfügbar.",
	widget: {
		SampleMyMachines: {
			title: "Meine Maschinen"
		},
		SampleMyServiceCalls: {
			title: "Servicefälle"
		},
		SampleMyTrackingList: {
			title: "Lieferstatus"
		},
		SampleMyUserAccount: {
			title: "Mein Profil"
		},
		SampleOperationalStatesChart: {
			title: "Betriebszustände"
		},
		SampleWidgetFilter: {
			title: " Filter Einstellungen"
		},
		SampleWorkloadBalanceChart: {
			title: "Auslastung"
		}
	}
};
var translation = {
	app: app,
	contentLoadingError: contentLoadingError,
	dashboard: dashboard,
	fileUpload: fileUpload,
	filter: filter,
	general: general,
	locationMap: locationMap,
	machineDiscontinuation: machineDiscontinuation,
	notifications: notifications,
	orderTracking: orderTracking,
	results: results,
	scrollToTop: scrollToTop,
	slider: slider,
	sorting: sorting,
	tab: tab,
	userAccount: userAccount,
	widget: widget,
	widgetRegistry: widgetRegistry
};

export { app, contentLoadingError, dashboard, translation as default, fileUpload, filter, general, locationMap, machineDiscontinuation, notifications, orderTracking, results, scrollToTop, slider, sorting, tab, userAccount, widget, widgetRegistry };
